import { makeQueryStringDync, errorServeiceHandler, makeQueryFormDataDyn } from '../helper'
const state = {
}
const getters = {
}
const mutations = {
}
const actions = {
  getActivation: (context, filterData) => {
    return new Promise((resolve, reject) => {
      let queryStr = ''
      queryStr = makeQueryStringDync(filterData)

      fetch(context.getters.baseUrl + '/lco/v1/activation.php' + queryStr, {
        method: 'GET'
      })
        .then(errorServeiceHandler)
        .then((response) => {
          return response.json()
        }).then((data) => {

          resolve(data)

        }).catch((error) => {

          reject(error);
        });
    });
  },
  getExpiryReport: (context, filterData) => {
    return new Promise((resolve, reject) => {
      let queryStr = ''
      queryStr = makeQueryStringDync(filterData)

      fetch(context.getters.baseUrl + '/lco/v1/expiry.php' + queryStr, {
        method: 'GET'
      })
        .then(errorServeiceHandler)
        .then((response) => {
          return response.json()
        }).then((data) => {

          resolve(data)

        }).catch((error) => {

          reject(error);
        });
    });
  },
  getExpiredReport: (context, filterData) => {
    return new Promise((resolve, reject) => {
      let queryStr = ''
      queryStr = makeQueryStringDync(filterData)

      fetch(context.getters.baseUrl + '/lco/v1/expiry.php/expired' + queryStr, {
        method: 'GET'
      })
        .then(errorServeiceHandler)
        .then((response) => {
            return response.json()
          }).then((data) => {
              resolve(data)
          }).catch((error) => {
            reject(error);
          });
        });
    },
    getBillsMonthReport: (context, ) => {
      return new Promise( (resolve, reject) => {
      fetch(context.getters.baseUrl + '/lco/v1/s3folderlist.php', {
          method: 'GET'
          })
          .then(errorServeiceHandler)
          .then((response) => {
              return response.json()
            }).then((data) => {
              if (context.getters.getMode == "development") {
                resolve({"2015":["JAN","FEB","MAR","APR","MAY","JUN","JUL","SEP","OCT","NOV","DEC"],"2016":["JAN","FEB","MAR","APR","MAY","JUN","JUL","AUG","SEP","OCT","NOV","DEC"],"2017":["JAN","FEB","MAR","APR","MAY","JUN","JUL","AUG","SEP","OCT","NOV","DEC"],"2018":["JAN","FEB","MAR","APR","MAY","JUN","JUL","AUG","SEP","OCT","NOV","DEC"],"2019":["JAN","FEB Supplement","FEB","MAR","APR","MAY","JUN","JUL","AUG","SEP","OCT","NOV","DEC"],"2020":["JAN","FEB","MAR","APR"],"temp":["CRF"]})
              }
              else {
                resolve(data)
              }
            }).catch((error) => {
                if (context.getters.getMode == "development") {
                  resolve({"2015":["JAN","FEB","MAR","APR","MAY","JUN","JUL","SEP","OCT","NOV","DEC"],"2016":["JAN","FEB","MAR","APR","MAY","JUN","JUL","AUG","SEP","OCT","NOV","DEC"],"2017":["JAN","FEB","MAR","APR","MAY","JUN","JUL","AUG","SEP","OCT","NOV","DEC"],"2018":["JAN","FEB","MAR","APR","MAY","JUN","JUL","AUG","SEP","OCT","NOV","DEC"],"2019":["JAN","FEB Supplement","FEB","MAR","APR","MAY","JUN","JUL","AUG","SEP","OCT","NOV","DEC"],"2020":["JAN","FEB","MAR","APR"],"temp":["CRF"]})
                  return
                } 
              reject(error);
            });
        });
    },
    getBillsReport: (context, filterData) => {
      return new Promise( (resolve, reject) => {
      let queryStr = ''
      queryStr = makeQueryStringDync(filterData)
      fetch(context.getters.baseUrl + '/lco/v1/bill.php' + queryStr, {
          method: 'GET'
          })
          .then(errorServeiceHandler)
          .then((response) => {
              return response.json()
            }).then((data) => {
              resolve(data)
            }).catch((error) => {
              reject(error);
            });
        });
    },
    getJobMoniterCReport: (context, filterData) => {
      return new Promise( (resolve, reject) => {
      let queryStr = ''
      queryStr = makeQueryStringDync(filterData)
      fetch(context.getters.baseUrl + '/lco/v1/plan/bulkjob' + queryStr, {
          method: 'GET'
          })
          .then(errorServeiceHandler)
          .then((response) => {
              return response.json()
            }).then((data) => {
              resolve(data)
            }).catch((error) => {
              reject(error);
            });
        });
    },
    getRefundReport: (context, filterData) => {
    return new Promise( (resolve, reject) => {
    let queryStr = ''
      queryStr = makeQueryStringDync(filterData)

      fetch(context.getters.baseUrl + '/lco/v1/commision.php' + queryStr, {
        method: 'GET'
      })
        .then(errorServeiceHandler)
        .then((response) => {
          return response.json()
        }).then((data) => {
          console.log("pass1")

          resolve(data)


        }).catch((error) => {
          reject(error);
        });
    });
  },
  getstbReplacementReport: (context, filterData) => {
    return new Promise((resolve, reject) => {
      let queryStr = ''
      queryStr = makeQueryStringDync(filterData)

      fetch(context.getters.baseUrl + '/lco/v1/hardware/swapreport' + queryStr, {
        method: 'GET'
      })
        .then(errorServeiceHandler)
        .then((response) => {
          return response.json()
        }).then((data) => {

          resolve(data)


        }).catch((error) => {
          reject(error);
        });
    });
  },
  getEKYCReport: (context, filterData) => {
    return new Promise((resolve, reject) => {
      let queryStr = ''
      queryStr = makeQueryStringDync(filterData)

      fetch(context.getters.baseUrl + '/lco/v1/subscriber/ekyc' + queryStr, {
        method: 'GET'
      })
        .then(errorServeiceHandler)
        .then((response) => {
          return response.json()
        }).then((data) => {

          resolve(data)

        }).catch((error) => {
          reject(error);
        });
    });
  },
  getScheduleReport: (context, filterData) => {
    return new Promise((resolve, reject) => {
      let queryStr = ''
      queryStr = makeQueryStringDync(filterData)

      fetch(context.getters.baseUrl + '/lco/v1/schedulereport' + queryStr, {
        method: 'GET'
      })
        .then(errorServeiceHandler)
        .then((response) => {
          return response.json()
        }).then((data) => {

          resolve(data)

        }).catch((error) => {
          reject(error);
        });
    });
  },
  getPaymentReport: (context, filterData) => {
    return new Promise((resolve, reject) => {
      let queryStr = ''
      queryStr = makeQueryStringDync(filterData)

      fetch(context.getters.baseUrl + '/lco/v1/lcopaymentreport.php' + queryStr, {
        method: 'GET'
      })
        .then(errorServeiceHandler)
        .then((response) => {
          return response.json()
        }).then((data) => {

          resolve(data)

        }).catch((error) => {
          reject(error);
        });
    });
  },
  getModifiedCustomerReport: (context, filterData) => {
      return new Promise( (resolve, reject) => {
      let queryStr = ''
        queryStr = makeQueryStringDync(filterData)
      
        fetch(context.getters.baseUrl + '/lco/v1/lcocustomerupdatereport' + queryStr, {
          method: 'GET'
          })
          .then(errorServeiceHandler)
          .then((response) => {
              return response.json()
            }).then((data) => {
              resolve(data)
            }).catch((error) => {
              reject(error);
            });
          });
    },
    getAccountStatmentDetails : (context, filterData) => {
      return new Promise( (resolve, reject) => {
      let queryStr = ''
        queryStr = makeQueryStringDync(filterData)
      
        fetch(context.getters.baseUrl + '/lco/v1/lco/ledgerreport' + queryStr, {
          method: 'GET'
          })
          .then(errorServeiceHandler)
          .then((response) => {
              return response.json()
            }).then((data) => {
              if (context.getters.getMode == "development") {
              resolve()
            }
            else {
              resolve(data)
            }
            }).catch((error) => {
              reject(error);
            });
          });
    },
    getLineGen: (context, filterData) => {
      return new Promise( (resolve, reject) => {
     
        fetch(context.getters.baseUrl + '/lco/v1/lco/lcnandgener', {
          method: 'GET'
          })
          .then(errorServeiceHandler)
          .then((response) => {
              return response.json()
            }).then((data) => {
              resolve(data)
            }).catch((error) => {
              if (context.getters.getMode == "development") {
                resolve([
                  {
                  "url": "https://s3.ap-south-1.amazonaws.com/com.kyc.dpcollection.incablenet.mum/LCN&GENER/MUMBAI/INDigital_Mumbai_GEN_I_30092020.pdf",
                  "name": "CHANNEL LINE UP"
                  },
                  {
                  "url": "https://s3.ap-south-1.amazonaws.com/com.kyc.dpcollection.incablenet.mum/LCN&GENER/MUMBAI/INDigital_Mumbai_GEN_II_30092020.pdf",
                  "name": "Channel Line Up GEN II"
                  }
                  ])
                }
                return
               reject(error);
            });
          });
    },
    getWalletDebit: (context, filterData) => {
      return new Promise( (resolve, reject) => {
        let queryStr = ''
        queryStr = makeQueryStringDync(filterData)
        fetch(context.getters.baseUrl + '/lco/v1/lco/debit' + queryStr, {
          method: 'GET'
          })
          .then(errorServeiceHandler)
          .then((response) => {
              return response.json()
            }).then((data) => {
              resolve(data)
            }).catch((error) => {
              if (context.getters.getMode == "development") {
                resolve({"count":"21","data":[{"paymentid":"4232","entityid":"h7juP6Xn","amount":"1.00","frcode":"FR5125","comment":"for testing purpose","authorisedby":"vaibhav","created":"2020-09-11 18:24:01","paymentmode":"CA"},{"paymentid":"4138","entityid":"h7juP6Xn","amount":"3.00","frcode":"FR5125","comment":"lco debit","authorisedby":"Megha","created":"2020-09-08 18:03:55","paymentmode":"CA"},{"paymentid":"4137","entityid":"h7juP6Xn","amount":"4.00","frcode":"FR5125","comment":"lco debit","authorisedby":"Megha","created":"2020-09-08 17:53:57","paymentmode":"CA"},{"paymentid":"4136","entityid":"h7juP6Xn","amount":"1.00","frcode":"FR5125","comment":"lco debit testing needs to be done1","authorisedby":"SANITH","created":"2020-09-08 17:06:22","paymentmode":"CA"},{"paymentid":"4135","entityid":"h7juP6Xn","amount":"1.00","frcode":"FR5125","comment":"lco debit testing needs to be done1","authorisedby":"SANITH","created":"2020-09-08 17:05:46","paymentmode":"CA"},{"paymentid":"4134","entityid":"h7juP6Xn","amount":"1.00","frcode":"FR5125","comment":"lco debit testing needs to be done","authorisedby":"SANITH","created":"2020-09-08 15:50:08","paymentmode":"CA"},{"paymentid":"4133","entityid":"h7juP6Xn","amount":"2.00","frcode":"FR5125","comment":"lco debit","authorisedby":"SANITH","created":"2020-09-08 15:43:05","paymentmode":"CA"},{"paymentid":"4132","entityid":"h7juP6Xn","amount":"1.00","frcode":"FR5125","comment":"lco debit","authorisedby":"test","created":"2020-09-08 15:40:57","paymentmode":"CA"},{"paymentid":"4131","entityid":"h7juP6Xn","amount":"1.00","frcode":"FR5125","comment":"lco debit","authorisedby":"Megha","created":"2020-09-08 15:39:32","paymentmode":"CA"},{"paymentid":"4130","entityid":"h7juP6Xn","amount":"10.00","frcode":"FR5125","comment":"lco debit","authorisedby":"test","created":"2020-09-08 15:39:02","paymentmode":"CA"},{"paymentid":"4127","entityid":"h7juP6Xn","amount":"1.00","frcode":"FR5125","comment":"lco debit","authorisedby":"Megha","created":"2020-09-08 15:34:55","paymentmode":"CA"},{"paymentid":"4128","entityid":"h7juP6Xn","amount":"1.00","frcode":"FR5125","comment":"testing","authorisedby":"Rukmini","created":"2020-09-08 15:34:55","paymentmode":"CA"},{"paymentid":"3400","entityid":"h7juP6Xn","amount":"50.62","frcode":"FR5125","comment":"Amount Debited towards Vishesh Manoranjan Pack","authorisedby":"VP","created":"2020-09-08 12:47:00","paymentmode":"CA"}]})
                }
                return
               reject(error);
            });
          });
    },
    getSingleCustomerPlanList: (context, payload) => {
      return new Promise((resolve, reject) => {
        if (!payload) {
          reject({ error: "payload not found" });
        }
        let dataObj = {};
        let queryStr = ''
        dataObj = {
          'subscriberid': payload,
          'page': '1',
          'pagelimit': '10'
        }
        queryStr = makeQueryStringDync(dataObj);
        fetch( context.getters.baseUrl + '/lco/v1/expiry/details' + queryStr, {
          method: 'GET'
        }) .then(errorServeiceHandler) .then((response) => {
          return response.json()
        }).then((data) => {
          resolve(data)
        }).catch((error) => {
          reject(error);
        });
      });
    },
    getConsolidatedData: (context, filterData) => {
      return new Promise( (resolve, reject) => {
        let queryStr = ''
        queryStr = makeQueryStringDync(filterData)
        fetch(context.getters.baseUrl + '/lco/v1/consolidatereport-list' + queryStr, {
          method: 'GET'
        }).then(errorServeiceHandler).then((response) => {
          return response.json()
        }).then((data) => {
          resolve(data)
        }).catch((error) => {
          reject(error);
        });
      });
    },
    getDCRefundData: (context, filterData) => {
      return new Promise( (resolve, reject) => {
        let queryStr = ''
        queryStr = makeQueryStringDync(filterData)
        fetch(context.getters.baseUrl + '/lco/v1/lcodcrefundreport/dcrefundreport' + queryStr, {
          method: 'GET'
        }).then(errorServeiceHandler).then((response) => {
          return response.json()
        }).then((data) => {
          resolve(data)
        }).catch((error) => {
          reject(error);
        });
      });
    },
    get15DaysReport: (context) => {
      return new Promise((resolve, reject) => {
        fetch(context.getters.baseUrl + 'lco/v1/expiry-download-report', {
          method: 'GET'
        })
        .then(errorServeiceHandler).then(response => response.blob()).then(blob => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'expiry15days.csv';
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);

          resolve(true);
        })
        .catch(error => {
          reject(error);
        });
      });
    }
};

export default {
  state, getters, mutations, actions
};



// WEBPACK FOOTER //
// ./src/store/modules/reportModule.js